import { render, staticRenderFns } from "./navbar-comp.vue?vue&type=template&id=3408f00b&scoped=true"
import script from "./navbar-comp.vue?vue&type=script&lang=js"
export * from "./navbar-comp.vue?vue&type=script&lang=js"
import style0 from "./navbar-comp.vue?vue&type=style&index=0&id=3408f00b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3408f00b",
  null
  
)

export default component.exports